export const RWDOMParser = DOMParser;
